import pushClevertapEvent from 'clevertap/pushClevertapEvent';

export function openPaymentConfiguration() {
  pushClevertapEvent('Open Payment Configuration');
}

export function addPaymentConfiguration() {
  pushClevertapEvent('Add Custom Payment Configuration');
}

export function savePaymentConfiguration(properties) {
  pushClevertapEvent('Save Custom Payment Configuration', {
    'Payment Configuration Name': properties.name,
    'List of Payment Method': properties.paymentMethods,
    'Total Payment Method': properties.paymentMethods.length,
    'Total Outlet Assigned': properties.outletCount,
  });
}
